import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { PartSearchComponent } from './part-search/part-search.component';
import { PartDetailComponent } from './part-detail/part-detail.component';
import { PartPurchasesComponent } from './part-purchases/part-purchases.component';
import { PartInventoryComponent } from './part-inventory/part-inventory.component';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { PartLookupDialogComponent } from './part-lookup-dialog/part-lookup-dialog.component';
import { PartPurchaseOrderDialogComponent } from './part-po-dialog/part-po-dialog.component';
import { PartCostComponent } from './part-cost/part-cost.component';
import { FrameOverviewComponent } from './frame-overview/frame-overview.component';
import { BulkEditDialogComponent } from './bulk-edit-dialog/bulk-edit-dialog.component';
import { InventoryUsageComponent } from './inventory-usage/inventory-usage.component';
import { ServiceChargeDialogComponent } from './service-charge-dialog/service-charge-dialog.component';
import { PartBulkEditOverviewComponent } from './part-bulk-edit-overview/part-bulk-edit-overview.component';
import { PartAliasDialogComponent } from './part-alias-dialog/part-alias-dialog.component';
import { PartNumberDialogComponent } from './part-number-dialog/part-number-dialog.component';
import { PartConfigurationComponent } from './part-configuration/part-configuration.component';
import { PartPricingComponent } from './part-pricing/part-pricing.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'parts',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'search', component: PartSearchComponent, data: { title: 'Parts' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'purchases', component: PartPurchasesComponent, data: { title: 'Adjustments' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'frames', component: FrameOverviewComponent, data: { title: 'Frames' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'inventory', component: PartInventoryComponent, data: { title: 'Inventory' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'usage', component: InventoryUsageComponent, data: { title: 'Inventory Usage' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'cost', component: PartCostComponent, data: { title: 'Part Cost Comparison' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'bulk-edit', component: PartBulkEditOverviewComponent, data: { title: 'Part Bulk Edit' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'configuration', component: PartConfigurationComponent, data: { title: 'Part Config' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'pricing', component: PartPricingComponent, data: { title: 'Part Pricing' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: ':id', component: PartDetailComponent, data: { title: 'Part Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        PartSearchComponent,
        PartDetailComponent,
        PartPurchasesComponent,
        PartInventoryComponent,
        PartLookupDialogComponent,
        PartPurchaseOrderDialogComponent,
        PartCostComponent,
        FrameOverviewComponent,
        BulkEditDialogComponent,
        InventoryUsageComponent,
        ServiceChargeDialogComponent,
        PartBulkEditOverviewComponent,
        PartAliasDialogComponent,
        PartNumberDialogComponent,
        PartConfigurationComponent,
        PartPricingComponent,
    ]
})
export class PartsModule {}
